import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  dialogOptions: {
    type: 'panel'
  }
} satisfies RecursivePartial<DialogConfig['default']>
